import { CLOUD_API_URL } from '../config/serverConfig';

function getAuthToken() {
  try {
    const stored = localStorage.getItem('maestro_auth');
    return stored ? JSON.parse(stored).accessToken : null;
  } catch {}
  return null;
}

export async function userCloudApiFetch(path, method = 'GET', body = null) {
  const token = getAuthToken();
  if (!token) return null;
  const opts = {
    method,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    credentials: 'omit',
  };
  if (body) opts.body = JSON.stringify(body);
  const res = await fetch(`${CLOUD_API_URL}${path}`, opts);
  if (!res.ok) return null;
  return res.json();
}
